import { object, string, number, array } from 'yup'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { language } from 'components/Wizards/schemas/shared/language'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { meta } from '../schemaCommon'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'

export const FlowRSchema = ({ generationType }: { generationType: string }) => {
  const BrainstormDetailsSchema = object({
    content_type: string()
      .oneOf([
        'Sales Strategy',
        'Customer Communication',
        'Product Information',
        'Meeting Preparation',
        'Sales Call Guide',
        'Customer Service',
        'Competitive Analysis',
        'Success Story',
        'Policy Document',
        'Transaction Communication',
      ])
      .default('Sales Strategy')
      .meta({
        label: '',
        placeholder: 'What type of sales content do you need?',
        oneOfPills: true,
      })
      .transform(safify),
    brand_kit_id: brandKitId
      .meta({
        label: 'Pick a Brand Kit',
      })
      .optional(),
    tone: tone.meta({
      autoFill: false,
    }),
  }).meta({
    title: 'What type of sales content do you need?',
    submitLabel: 'Continue',
  }) as StepSchema

  const RefinementSchema = object({
    topic: topic.meta({
      type: 'textarea',
      autoFill: true,
      generate: false,
      generationType,
    }),
    ideas_count: number().default(5).oneOf([3, 5, 7, 10]).meta({
      label: 'How many variations?',
    }),
  }).meta({
    title: 'What would you like to focus on?',
    submitLabel: 'Continue',
  }) as StepSchema

  const KeywordsSchema = object({
    seo_words: array().of(string()).min(1, 'Please add at least one keyword').default([]).meta({
      label: 'Key terms to include',
      autoFill: true,
      placeholder: 'Add important terms (press enter or tab to separate)',
    }),
    filename,
    project,
    language: language.meta({ overflow: true }),
    include_emojis: includeEmojis.meta({ overflow: true }),
  }).meta({
    title: 'Add final details',
    submitLabel: 'Generate Content',
  }) as StepSchema

  return {
    meta,
    steps: [BrainstormDetailsSchema, RefinementSchema, KeywordsSchema],
  } as MultiStepSchema<GenerationType>
}
